export default "__VITE_ASSET__BBtOISqS__"